import { Type } from '@angular/core';
import { RepositoryComponent } from './repository.component';

export * from "./repository.component";

export const REPOSITORY_DIRECTIVES: Type<any>[] = [
  RepositoryComponent
];
